import React from 'react';
import Icon from '../../../components/AppIcon';
import { Checkbox } from '../../../components/ui/Checkbox';
import Input from '../../../components/ui/Input';

const DoNotDisturbScheduling = ({ preferences, onUpdate }) => {
  const handleTimeChange = (field, value) => {
    // Validate time format (HH:MM)
    const timeRegex = /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/;
    if (timeRegex?.test(value) || value === '') {
      onUpdate({ [field]: value });
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-start gap-3 mb-6">
        <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
          <Icon name="Moon" size={20} className="text-primary" />
        </div>
        <div className="flex-1">
          <h2 className="text-lg font-semibold text-foreground">Do Not Disturb Scheduling</h2>
          <p className="text-sm text-muted-foreground mt-1">
            Set custom time ranges when you don't want to receive non-critical notifications.
          </p>
        </div>
      </div>
      <div className="space-y-6">
        {/* Enable DND */}
        <div>
          <Checkbox
            checked={preferences?.enabled || false}
            onChange={(e) => onUpdate({ enabled: e?.target?.checked })}
            label="Enable Do Not Disturb"
            description="Silence non-critical notifications during specified hours"
          />
        </div>

        {/* Time Range */}
        {preferences?.enabled && (
          <>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div>
                <Input
                  label="Start Time"
                  type="time"
                  value={preferences?.startTime || '22:00'}
                  onChange={(e) => handleTimeChange('startTime', e?.target?.value)}
                  description="When DND begins"
                />
              </div>
              <div>
                <Input
                  label="End Time"
                  type="time"
                  value={preferences?.endTime || '08:00'}
                  onChange={(e) => handleTimeChange('endTime', e?.target?.value)}
                  description="When DND ends"
                />
              </div>
            </div>

            {/* Timezone Display */}
            <div className="bg-muted/50 rounded-lg p-3 flex items-center gap-3">
              <Icon name="Globe" size={16} className="text-muted-foreground" />
              <div className="text-sm text-muted-foreground">
                <span className="font-medium">Timezone:</span> {preferences?.timezone || 'America/New_York'}
              </div>
            </div>

            {/* Override Options */}
            <div className="space-y-3">
              <label className="text-sm font-medium text-foreground">Override Options</label>
              <Checkbox
                checked={preferences?.weekendOverride || false}
                onChange={(e) => onUpdate({ weekendOverride: e?.target?.checked })}
                label="Extend DND on Weekends"
                description="Apply Do Not Disturb all day on Saturdays and Sundays"
              />
              <Checkbox
                checked={preferences?.holidayOverride || false}
                onChange={(e) => onUpdate({ holidayOverride: e?.target?.checked })}
                label="Extend DND on Holidays"
                description="Apply Do Not Disturb all day on recognized holidays"
              />
            </div>

            {/* DND Preview */}
            <div className="bg-muted/50 rounded-lg p-4 flex items-start gap-3">
              <Icon name="Info" size={16} className="text-muted-foreground flex-shrink-0 mt-0.5" />
              <div className="text-xs text-muted-foreground">
                <p className="font-medium mb-1">Do Not Disturb Preview</p>
                <p>
                  Non-critical notifications will be silenced from{' '}
                  <strong>{preferences?.startTime || '22:00'}</strong> to{' '}
                  <strong>{preferences?.endTime || '08:00'}</strong> daily.
                  Critical alerts will still be delivered immediately.
                </p>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default DoNotDisturbScheduling;